// extracted by mini-css-extract-plugin
export var closebtn = "minicart-module--closebtn--68087";
export var hiding = "minicart-module--hiding--e763f";
export var minicartWrapper = "minicart-module--minicartWrapper--3b5ba";
export var overlay = "minicart-module--overlay--7d3a8";
export var showing = "minicart-module--showing--a30cf";